import React from 'react';
import { Button } from './ui/button';
import { AlertTriangle, RefreshCcw, RotateCcw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Surface the real error so the blank-page crash becomes diagnosable
    console.error('Page render error caught by ErrorBoundary:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 p-6">
          <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 text-center shadow-sm">
            <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-amber-600" />
            </div>
            <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
              Une erreur est survenue lors du chargement de la page
            </h2>
            <p className="text-sm text-slate-600 dark:text-slate-400 mb-6">
              Veuillez réessayer. Si le problème persiste, rechargez la page.
            </p>
            <div className="flex items-center justify-center gap-3">
              <Button variant="outline" onClick={this.handleRetry}>
                <RotateCcw className="w-4 h-4 mr-2" />
                Réessayer
              </Button>
              <Button className="bg-violet-600 hover:bg-violet-700" onClick={this.handleReload}>
                <RefreshCcw className="w-4 h-4 mr-2" />
                Recharger la page
              </Button>
            </div>
            {this.state.error?.message && (
              <p className="mt-4 text-xs text-slate-400 break-words">
                {this.state.error.message}
              </p>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
